// eslint-disable-next-line import/no-cycle
import router from '@/router';

export default {
  state: {
    isFreeToProPopupVisible: false,
    isPremiumSuccessPopupVisible: false,
    isProSuccessPopupVisible: false,
    isProToFreePopupVisible: false,
    isPremiumToFreePopupVisible: false,
    isPremiumToProPopupVisible: false,
    isProToPremiumPopupVisible: false,
    isDowngradeConfirmationPopupVisible: false,
    popupConfirmHandler: () => {},
    modalConfirmHandler: () => {},
    stripeSetup: {
      isVisible: false,
      handlers: {},
    },
  },
  getters: {
    isFreeToProPopupVisible: state => state.isFreeToProPopupVisible,
    isPremiumSuccessPopupVisible: state => state.isPremiumSuccessPopupVisible,
    isProSuccessPopupVisible: state => state.isProSuccessPopupVisible,
    isProToFreePopupVisible: state => state.isProToFreePopupVisible,
    isPremiumToFreePopupVisible: state => state.isPremiumToFreePopupVisible,
    isPremiumToProPopupVisible: state => state.isPremiumToProPopupVisible,
    isProToPremiumPopupVisible: state => state.isProToPremiumPopupVisible,
    isDowngradeConfirmationPopupVisible: state => state.isDowngradeConfirmationPopupVisible,
    paidTierPopupConfirmHandler: state => state.popupConfirmHandler,
    paidTierModalConfirmHandler: state => state.modalConfirmHandler,
    isSetupStripePopupVisible: state => state.stripeSetup.isVisible,
    setupStripePopupHandlers: state => state.stripeSetup.handlers,
  },
  mutations: {
    closeFreeToProPopup(state) {
      state.isFreeToProPopupVisible = false;
    },
    closePremiumSuccessPopup(state) {
      state.isPremiumSuccessPopupVisible = false;
    },
    closeProSuccessPopup(state) {
      state.isProSuccessPopupVisible = false;
    },
    closeProToFreePopup(state) {
      state.isProToFreePopupVisible = false;
    },
    closePremiumToFreePopup(state) {
      state.isPremiumToFreePopupVisible = false;
    },
    closePremiumToProPopup(state) {
      state.isPremiumToProPopupVisible = false;
    },
    closeProToPremiumPopup(state) {
      state.isProToPremiumPopupVisible = false;
    },
    closeDowngradeConfirmationPopup(state) {
      state.isDowngradeConfirmationPopupVisible = false;
    },
    openFreeToProPopup(state) {
      state.isFreeToProPopupVisible = true;
    },
    openPremiumSuccessPopup(state) {
      state.isPremiumSuccessPopupVisible = true;
    },
    openProSuccessPopup(state) {
      state.isProSuccessPopupVisible = true;
    },
    openProToFreePopup(state) {
      state.isProToFreePopupVisible = true;
    },
    openPremiumToFreePopup(state) {
      state.isPremiumToFreePopupVisible = true;
    },
    openPremiumToProPopup(state) {
      state.isPremiumToProPopupVisible = true;
    },
    openProToPremiumPopup(state) {
      state.isProToPremiumPopupVisible = true;
    },
    setPopupConfirmationHandler(state, handler) {
      state.popupConfirmHandler = handler;
    },
    setModalConfirmationHandler(state, handler) {
      state.modalConfirmHandler = handler;
    },
    openDowngradeConfirmationPopup(state) {
      state.isDowngradeConfirmationPopupVisible = true;
    },
    openSetupStripePopup(state) {
      state.stripeSetup.isVisible = true;
    },
    closeSetupStripePopup(state) {
      state.stripeSetup.isVisible = false;
    },
    setSetupStripeCallbacks(state, handlers) {
      state.stripeSetup.handlers = handlers;
    },
  },
  actions: {
    openSetupStripePopup({ commit, dispatch }, { closeCallback, successCallback } = {}) {
      commit('openSetupStripePopup');
      commit('setSetupStripeCallbacks', {
        handleOnPopupClose: async () => {
          await closeCallback?.();
          dispatch('closeSetupStripePopup');
        },
        handleOnPopupSuccess: async () => {
          await successCallback?.();
          dispatch('closeSetupStripePopup');
          await router.push({ name: 'PaymentSettings' });
        },
      });
    },
    closeSetupStripePopup({ commit }) {
      commit('closeSetupStripePopup');
      commit('setSetupStripeCallbacks', {});
    },
  },
};
